import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikCalle from "../../../../../../commons/formik/direcciones/FormikCalle";
import FormikLocalidad from "../../../../../../commons/formik/direcciones/FormikLocalidad";
import FormikNumero from "../../../../../../commons/formik/direcciones/FormikNumero";
import FormikPais from "../../../../../../commons/formik/direcciones/FormikPais";
import FormikProvincia from "../../../../../../commons/formik/direcciones/FormikProvincia";
import FormikActions from "../../../../../../commons/formik/FormikActions";
import FormikCheckbox from "../../../../../../commons/formik/FormikCheckbox";
import FormikTextField from "../../../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../../styled/Prevencion";
import { ValidateProveedor } from "../../formValidations";

const nameLocationFields = {
    pais: "pais",
    provincia: "provincia",
    localidad: "localidad",
    calle: "calle",
    numero: "numero",
}

const ProveedoresForm = ({ values, open, handleClose, handleSubmit, id, loading, initialFormValues }) => {
    const proveedores = useSelector((state) => state.resolucion.abmSustancia.proveedores);
    return (
        <Dialog open={open} >
            <DialogTitle>Proveedor/Comprador</DialogTitle>

            {loading ?
                <CircularLoading />
                : (

                    <Formik
                        initialValues={values}
                        onSubmit={(values) => handleSubmit(values)}
                        validationSchema={ValidateProveedor(proveedores, id)}
                    >
                        {() => (
                            <Form>
                                <DialogContent>
                                    <Grid container>
                                        {/* Primer fila */}
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikTextField
                                                name="razonSocial"
                                                label="Razon Social*"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikTextField
                                                name="cuit"
                                                label="CUIT*"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikCheckbox
                                                name="esComprador"
                                                label="¿Es Comprador?"
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        {/*Segunda fila */}
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikPais
                                                nameLocationFields={nameLocationFields}
                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikProvincia
                                                nameLocationFields={nameLocationFields}
                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikLocalidad
                                                nameLocationFields={nameLocationFields}
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        {/*Tercera fila */}
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikCalle
                                                nameLocationFields={nameLocationFields}
                                                calleInicial={initialFormValues?.calle ?? ""}
                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikNumero
                                                label="Número*"
                                                nameLocationFields={nameLocationFields}
                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={2} >
                                            <FormikTextField name="piso" label="Piso" fullWidth />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={2} >
                                            <FormikTextField
                                                name="departamento"
                                                label="Dpto"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        {/* Cuarta fila */}

                                        <StyledResolucion.DialogGridItem item xs={4} >
                                            <FormikTextField
                                                name="codigoPostal"
                                                label="Código Postal *"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>
                                    </Grid>
                                </DialogContent>

                                <DialogActions>
                                    <FormikActions handleCancel={handleClose} />
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                )
            }

        </Dialog>
    )
}

export default ProveedoresForm;